import React from 'react';
import { Section } from './Section';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <Section className="bg-sage" data-id="element-89">
      <div className="flex flex-col items-center text-center mb-10" data-id="element-90">
        <AlertCircle className="w-12 h-12 text-forest mb-4" data-id="element-91" />
        <h2 className="font-serif text-3xl md:text-4xl text-forest font-bold mb-6" data-id="element-92">
          El escenario perfecto para la inflamación
        </h2>
      </div>
      <div className="bg-white rounded-2xl p-8 md:p-10 shadow-xl border border-sage-dark" data-id="element-93">
        <p className="text-gray-700 text-lg leading-relaxed mb-6" data-id="element-94">
          Vivir en Estados Unidos es el escenario perfecto para la inflamación.
          El estrés del trabajo, el aire acondicionado constante y el sodio
          oculto en la comida del supermercado mantienen tus niveles de cortisol
          por las nubes.
        </p>
        <p className="text-gray-700 text-lg leading-relaxed font-medium" data-id="element-95">
          Tu cuerpo no está acumulando grasa de la noche a la mañana; está
          atrapado en un estado de alerta, reteniendo cada gota de agua para
          "sobrevivir" al ritmo de vida actual. Por eso, comer menos ensaladas o
          hacer más cardio no funciona: solo estresa más a tu organismo.
        </p>
      </div>
    </Section>;
}